module.exports = __webpack_public_path__ + "img/17_terawatts.d625b87f.jpg";